import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Redirect, Route, Switch } from 'react-router-dom';


import TravelExpenseRequest from './travel-expense/create';
import EditRequest from './travel-expense/edit';
import SideBar from '../components/sidebar';
import Header from '../components/header';
import Footer from '../components/footer';
import NotFound from './not-found';
import RequestsPage from './travel-expense/detail/user';
import EmployeeReportsPage from './travel-expense/reports/employee';
import HelpPage from './help';
import Security from './security';
import ErrorPage from './error';
import * as authActions from "../redux/modules/auth";
import cookieAndLocalStorage from "../helpers/cookieAndLocalStorage";
import { startTokenChecker, stopTokenChecker } from "../helpers/TokenChecker";



class App extends Component {
    async componentDidMount() {
        const { isCheckToken, isActive } = this.props;
        if (isActive === false) {
            cookieAndLocalStorage();
            return;
        }
        // İlk anda hemen token kontrolü yap
        await isCheckToken();
        // Sonra periyodik kontrolü başlat
        startTokenChecker(isCheckToken);
    }

    componentWillUnmount() {
        stopTokenChecker();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isActive === false) {
            cookieAndLocalStorage();
        }
    }

    render() {
        return (
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Header />
                    <div className="content">
                        <div className="container-fluid">
                            <Switch>
                                <Redirect exact from="/" to="/travel-expense-request" />
                                <Route path="/travel-expense-request" component={TravelExpenseRequest} />
                                <Route path="/requests/:page?" component={RequestsPage} />
                                <Route path="/reports/:page?" component={EmployeeReportsPage} />
                                <Route path="/help" component={HelpPage} />
                                <Route path="/edit-request/:id" component={EditRequest} />
                                <Route path="/security" component={Security} />
                                <Route path="/error" component={ErrorPage} />
                                <Route component={NotFound} />
                            </Switch>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    isActive: state.auth.isActive,
    isCheckToken: state.auth.isCheckToken,
    logout: state.auth.logout
});

const actions = { ...authActions, push,  };

export default connect(mapStateToProps, actions)(App);



// WEBPACK FOOTER //
// ./src/pages/App.js